var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FE572A",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7175 26.8047L22.3932 48.0967L38.7673 66.29L60.9997 44.0576V26.8047H42.7175ZM64.9997 44.0576C64.9997 45.1183 64.5787 46.1356 63.8288 46.8857L41.5964 69.1182C39.9759 70.7386 37.3277 70.6692 35.7946 68.9658L19.4206 50.7725C18.0215 49.2179 18.0557 46.8479 19.4997 45.335L39.8239 24.043C40.5787 23.2523 41.6244 22.8047 42.7175 22.8047H60.9997C63.2088 22.8047 64.9997 24.5955 64.9997 26.8047V44.0576Z",
    fill: "#FE572A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 36.5C53.5 34.8431 52.1569 33.5 50.5 33.5C48.8431 33.5 47.5 34.8431 47.5 36.5C47.5 38.1569 48.8431 39.5 50.5 39.5C52.1569 39.5 53.5 38.1569 53.5 36.5ZM56.5 36.5C56.5 39.8137 53.8137 42.5 50.5 42.5C47.1863 42.5 44.5 39.8137 44.5 36.5C44.5 33.1863 47.1863 30.5 50.5 30.5C53.8137 30.5 56.5 33.1863 56.5 36.5Z",
    fill: "#FE572A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.a1390210d3a35ba6a8ae540017a06a8b.svg";
export { ForwardRef as ReactComponent };